import { render, staticRenderFns } from "./div-text.vue?vue&type=template&id=a5612a1c&scoped=true"
import script from "./div-text.vue?vue&type=script&lang=js"
export * from "./div-text.vue?vue&type=script&lang=js"
import style0 from "./div-text.vue?vue&type=style&index=0&id=a5612a1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5612a1c",
  null
  
)

export default component.exports